import { Component } from '@angular/core';
import { ConnectionStatus } from 'src/app/swagger-api/model/connectionStatus';
import { TableCellState } from '../../table.state';
import { CellActionTypes } from '../cell-actions.type';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { TableTooltipConfig } from '../../config/table-tooltip.config';

@Component({
  selector: 'app-cell-manage-relation',
  templateUrl: './cell-manage-relation.html',
  styleUrls: ['./cell-manage-relation.scss'],
  providers: [{ provide: NgbTooltipConfig, useClass: TableTooltipConfig }],
})
export class CellManageRelationComponent extends TableCellState {
  public readonly ConnectionStatus: typeof ConnectionStatus = ConnectionStatus;

  public sendMessage(): void {
    this.onAction(CellActionTypes.SEND_MSG);
  }

  public add(): void {
    this.onAction(CellActionTypes.ADD);
  }

  public remove(): void {
    this.onAction(CellActionTypes.REMOVE);
  }
}
